function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.9548 10.121L21.9548 10.121C22.0028 10.5433 21.8632 10.9296 21.6086 11.2141L21.1608 11.7143L21.6086 12.2145C22.2988 12.9855 21.9328 14.2157 20.9378 14.4868L20.1291 14.7071L20.4377 15.4865C20.5008 15.646 20.5357 15.8189 20.5357 16C20.5357 16.6391 20.1005 17.1829 19.5093 17.3439L18.7005 17.5643L19.0091 18.3437C19.3741 19.2653 18.6781 20.25 17.5644 20.25H12.8919C10.623 20.25 9.05685 19.7502 7.75 19.3092V9.59599C8.48321 9.23363 9.18563 8.86505 9.95992 8.09076L9.95993 8.09075C10.7059 7.34479 11.2124 6.14253 11.5342 5.0062C11.8582 3.86181 12.0312 2.65136 12.0356 1.75H12.5894C13.8086 1.75 14.8072 2.72746 14.8211 3.9281C14.8261 4.36752 14.77 5.17065 14.6526 5.97182C14.5944 6.36937 14.523 6.75291 14.4407 7.08047C14.3554 7.42031 14.2698 7.65255 14.2002 7.77717L13.5771 8.89285H14.855H20.4238C21.2244 8.89285 21.8791 9.45487 21.9548 10.121Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.80725 8.75H5.03618C5.06595 8.75 5.08454 8.75985 5.09337 8.7669V20.7631C5.08452 20.7701 5.0659 20.78 5.03612 20.78H1.80725C1.77746 20.78 1.75884 20.7701 1.75 20.7631V8.76694C1.75885 8.75987 1.77747 8.75 1.80725 8.75Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgLike = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Like.751aa179.svg";
export { ForwardRef as ReactComponent };